// extracted by mini-css-extract-plugin
module.exports = {"content":"CustomDialogContent_content__3dFpq","block":"CustomDialogContent_block__2f-Gc","flex":"CustomDialogContent_flex__3C05I","padded":"CustomDialogContent_padded__89-Js"};